export const NORMAL_SUPPLIER_ORDER_TYPES = ['C'];
export const NON_PRIME_ORDER_REASONS = ['34', 'ZB', '24', '25'];

export interface ClaimBatch {
	id: string;
	customerOrderNumber: string;
	customerOrderItemNumber: string;
	supplierOrderNumber: string;
	supplierOrderItemNumber: string;
	supplierOrderType: string;
	batchReference: string;
	qtyBatchNet: number;
	qtyBatchGross: number;
	steelgrade: string;
	steelgradeDescription: string;
	customerArticleReference: string;
	thicknessDimension: number;
	widthDimension: number;
	lengthDimension: number;
	statusGroup: string;
	statusGroupDescription: string;
	status: string;
	statusDescription: string;
	currentLocation: string;
	currentLocationDescription: string;
	soldTo: string;
	soldToDescription: string;
	shipTo: string;
	cdd: string;
	cddWeek?: string;
	millOrderNumber: string;
	millOrderItemNumber: string;
	packageSerialNumber: string;
	heatNumber: string;
	mill: string;
	millDescription: string;
	finalUse: string;
	finalUseDescription: string;
	readyToShipDate: string;
	plannedShipmentDate: string;
	daysInStock: number;
	millBatchReference: string;
	sfcC: string;
	sfcCDescription: string;
	weightUnit: string;
	qtyInvoiced: number;
	weightUnitInvoiced: 'TO' | 'PC' | 'KG' | 'M2';
	numberOfPieces: number;
	currencyInvoiced: '' | 'USD' | 'SEK' | 'RON' | 'PLN' | 'GBP' | 'EUR' | 'CZK';
	isClaimable?: boolean | undefined;
	lastDispatchAdviceNumber: string;
	lastDispatchAdviceDate: string;
	claimedQuantity?: number | undefined;
	claimedQuantityUnit?: string | undefined;
	batchInvoiced: string;
	invoiceDate: string;
}

export type FieldOfClaimBatch = keyof ClaimBatch;

export const batchCardFields: readonly FieldOfClaimBatch[] = <const> [
	'id',
	'steelgrade',
	'steelgradeDescription',
	'customerArticleReference',
	'customerOrderNumber',
	'customerOrderItemNumber',
	'supplierOrderNumber',
	'supplierOrderItemNumber',
	'thicknessDimension',
	'widthDimension',
	'lengthDimension',
	'millOrderNumber',
	'millOrderItemNumber',
	'qtyBatchGross',
	'qtyBatchNet',
	'packageSerialNumber',
	'heatNumber',
	'mill',
	'millDescription',
	'finalUse',
	'finalUseDescription',
	'batchReference',
	'readyToShipDate',
	'plannedShipmentDate',
	'daysInStock',
	'currentLocation',
	'currentLocationDescription',
	'status',
	'statusDescription',
	'statusGroup',
	'statusGroupDescription',
	'millBatchReference',
	'sfcC',
	'sfcCDescription',
	'weightUnit',
	'qtyInvoiced',
	'weightUnitInvoiced',
	'numberOfPieces',
	'currencyInvoiced',
	'soldToDescription',
	'soldTo',
	'lastDispatchAdviceNumber'
];
